$('.past-names__toggler').click(function(){
    $(this).toggleClass('active');
    $(this).siblings('.past-names__content').slideToggle();
});
